__turbopack_context__.v({
  "emptyText": "filterTags-module-scss-module__gbADma__emptyText",
  "nonRemovableTag": "filterTags-module-scss-module__gbADma__nonRemovableTag",
});
